'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/9/8.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRadio = require('react-radio');

var _reactRadio2 = _interopRequireDefault(_reactRadio);

var _GoeasyRadio = require('../GoeasyInputField/GoeasyRadio');

var _GoeasyRadio2 = _interopRequireDefault(_GoeasyRadio);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderWritingInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OrderWritingInfo, _Component);

  function OrderWritingInfo() {
    (0, _classCallCheck3.default)(this, OrderWritingInfo);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OrderWritingInfo).call(this));
  }

  (0, _createClass3.default)(OrderWritingInfo, [{
    key: 'onExpressTypeChange',
    value: function onExpressTypeChange(val) {
      var expressTypeChange = this.props.expressTypeChange;

      if (expressTypeChange) {
        expressTypeChange(val);
      }
    }
  }, {
    key: 'onAddressChange',
    value: function onAddressChange(val) {
      var addressChange = this.props.addressChange;

      if (addressChange) {
        addressChange(val);
      }
    }
  }, {
    key: 'onFieldChange',
    value: function onFieldChange(val, field) {
      var fieldChange = this.props.fieldChange;

      if (fieldChange) {
        fieldChange(val, field);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./OrderWritingInfo.scss');
      var data = this.props.data;

      var expressTypeOptions = [];
      if (data && data.expressTypeList instanceof Array) {
        expressTypeOptions = data.expressTypeList.map(function (currentExpressType, index) {
          return _react2.default.createElement(_GoeasyRadio2.default, { key: index, Id: 'expressType_' + currentExpressType.value, currentData: currentExpressType });
        });
      }
      var addressIdOptions = [];
      if (data && data.addressIdList instanceof Array) {
        addressIdOptions = data.addressIdList.map(function (currentAddress, index) {
          return _react2.default.createElement(_GoeasyRadio2.default, { key: index, Id: 'address_' + currentAddress.value, currentData: currentAddress });
        });
      }
      /*    let expressCompanyOptions = [];
       if (data && data.expressCompanyList instanceof Array) {
       expressCompanyOptions = data.expressCompanyList.map((currentCompany, index)=> {
       return (<GoeasyRadio key={index} Id={'expressCompany_' + currentCompany.value} currentData={currentCompany}/>);
       });
       }
       let expressProductOptions = [];
       if (data && data.expressProductList instanceof Array) {
       expressProductOptions = data.expressProductList.map((currentExpressProduct, index)=> {
       return (<GoeasyRadio key={index} Id={'expressProduct_' + currentExpressProduct.value}
       currentData={currentExpressProduct}/>);
       });
       }*/
      var authOptions = [];
      if (data && data.authIdList instanceof Array) {
        authOptions = data.authIdList.map(function (auth, index) {
          return _react2.default.createElement(
            'option',
            { key: index, Id: 'authId_' + auth.value, value: auth.value },
            auth.label
          );
        });
      }
      authOptions.splice(0, 0, _react2.default.createElement(
        'option',
        { key: 'null', value: '' },
        ' -- 请选择 -- '
      ));
      var invoiceOptions = [];
      if (data && data.invoiceIdList instanceof Array) {
        invoiceOptions = data.invoiceIdList.map(function (invoice, index) {
          return _react2.default.createElement(
            'option',
            { key: index, Id: 'invoice_' + invoice.value, value: invoice.value },
            invoice.label
          );
        });
      }
      invoiceOptions.splice(0, 0, _react2.default.createElement(
        'option',
        { key: 'null', value: '' },
        ' -- 请选择 -- '
      ));
      var invoiceDiv = '';
      if (data.isInvoiceWithExpress === '1') {
        invoiceDiv = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            { className: styles.mt20, style: { marginLeft: '66px' } },
            '发票：'
          ),
          _react2.default.createElement(
            'select',
            { className: styles.selt,
              value: data.invoiceId,
              onChange: function onChange(event) {
                return _this2.onFieldChange(event.target.value, 'invoiceId');
              } },
            invoiceOptions
          ),
          _react2.default.createElement(
            'h4',
            { className: styles.mt20 + ' ' + styles.ml105 },
            '开票项目：'
          ),
          _react2.default.createElement(
            'span',
            { className: styles.txt },
            data.projectType
          ),
          _react2.default.createElement(
            'h4',
            { className: styles.mt20 + ' ' + styles.ml105 },
            '发票类型：'
          ),
          _react2.default.createElement(
            'span',
            { className: styles.txt },
            data.invoiceType
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.singleItem },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'i',
              null,
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_js_bg1.png', alt: '' })
            ),
            _react2.default.createElement(
              'span',
              null,
              '艺品配送'
            ),
            _react2.default.createElement('div', { className: 'clear' })
          ),
          _react2.default.createElement('div', { className: styles.alink }),
          _react2.default.createElement(
            'div',
            { className: styles.cont_box },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(
                'h3',
                null,
                '配送方式'
              )
            ),
            _react2.default.createElement(
              _reactRadio2.default,
              { className: styles.rada, value: data.expressType,
                name: 'expressType' },
              expressTypeOptions
            )
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.cont_box },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(
                'h3',
                null,
                '地址选择'
              )
            ),
            _react2.default.createElement(
              _reactRadio2.default,
              { className: styles.rada, name: 'addressId', value: data.addressId,
                onChange: function onChange(val) {
                  return _this2.onFieldChange(val, 'addressId');
                } },
              addressIdOptions
            ),
            _react2.default.createElement(
              'span',
              { style: { display: 'none' }, className: styles.buttonModify },
              '修改'
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'h6',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/personalcenter/personalinfo/addressmanager' },
                '+新增地址'
              )
            ),
            _react2.default.createElement(
              'span',
              { style: { display: 'none' }, className: styles.link_a },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_js_bg2.png',
                alt: '' })
            )
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.cont_box },
            _react2.default.createElement(
              'h6',
              null,
              '配送费：',
              _react2.default.createElement(
                'em',
                null,
                data.expressCost
              )
            )
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.singleItem },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'i',
              null,
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_js_bg3.png', alt: '' })
            ),
            _react2.default.createElement(
              'span',
              null,
              '艺品授权'
            ),
            _react2.default.createElement('div', { className: 'clear' })
          ),
          _react2.default.createElement('div', { className: styles.alink }),
          _react2.default.createElement(
            'div',
            { className: styles.cont_box },
            _react2.default.createElement(
              'h4',
              { style: { marginLeft: '66px' } },
              '姓名：'
            ),
            _react2.default.createElement(
              'select',
              { className: styles.inpt,
                value: data.authId,
                onChange: function onChange(event) {
                  return _this2.onFieldChange(event.target.value, 'authId');
                } },
              authOptions
            ),
            _react2.default.createElement(
              'h4',
              { className: styles.ml105 },
              '电话：'
            ),
            _react2.default.createElement(
              'span',
              { className: styles.txt },
              data.personalMobile
            ),
            _react2.default.createElement(
              'h6',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/personalcenter/personalinfo/authmanager' },
                '+新增授权人'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.singleItem },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'i',
              null,
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_js_bg4.png', alt: '' })
            ),
            _react2.default.createElement(
              'span',
              null,
              '艺品发票'
            ),
            _react2.default.createElement('div', { className: 'clear' })
          ),
          _react2.default.createElement('div', { className: styles.alink }),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '10px', marginLeft: '66px' } },
            _react2.default.createElement('img', {
              onClick: function onClick() {
                return _this2.onFieldChange(data.isInvoiceWithExpress === '1' ? '0' : '1', 'isInvoiceWithExpress');
              },
              className: styles.checkImg,
              src: data.isInvoiceWithExpress === '1' ? 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/radio_hover.png' : 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/radio.png',
              alt: '' }),
            _react2.default.createElement(
              'span',
              { style: { fontSize: '16px', marginLeft: '7px', fontFamily: 'Microsoft YaHei' } },
              '需要发票'
            )
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.cont_box + ' ' + styles.mt0 },
            invoiceDiv,
            _react2.default.createElement(
              'h6',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/personalcenter/personalinfo/invoicemanager' },
                '+新增发票'
              )
            )
          )
        )
      );
    }
  }]);
  return OrderWritingInfo;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  expressTypeChange: _react.PropTypes.func,
  addressChange: _react.PropTypes.func,
  fieldChange: _react.PropTypes.func,
  expressProductChange: _react.PropTypes.func,
  authChange: _react.PropTypes.func,
  invoiceChange: _react.PropTypes.func,
  needInvoiceChange: _react.PropTypes.func
}, _temp);
exports.default = OrderWritingInfo;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OrderWritingInfo/OrderWritingInfo.js
 ** module id = 1385
 ** module chunks = 0
 **/